module.exports = __webpack_public_path__ + "static/media/machismo_dra_fromow.8dfe7545.png";